app.controller('MainController', ['$scope', '$location', function ($scope, $location) {
	sessionStorage.removeItem('registrationData'); // kiszedjük a session storage-ből a szerződésbevonásos adatokat, hogy ne jelenjenek meg, mert a menüpontból jutott a regisztrációs felületre
	try {
        /*if(isSignedIn) {
            $location.path('/belepve');
        }
        else {*/
            $location.path('/adatok');
        //}
    } catch(e) {
		console.error(e);
		$location.path('/adatok');
    }

}]);
